export default __webpack_public_path__ + "static/media/enter.6c6af768.svg";